module.exports = __webpack_public_path__ + "img/default-avatar.f9acb3e4.png";